import type { AuthAdapter } from "@/core/auth/adapter";
import { Outlet, createRootRouteWithContext, redirect } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<{ authAdapter: AuthAdapter }>()({
	// Admin surface requires a session; bounce back here after login.
	beforeLoad({ location, context }) {
		if (!location.pathname.startsWith("/admin")) return;

		if (context.authAdapter.getState().status !== "authenticated") {
			throw redirect({ to: "/login", search: { redirect: location.href ?? "/admin" } });
		}
	},
	component: () => <Outlet />,
});
